<div class="branch-promo__intro">
  <ng-content></ng-content>
</div>
